import { render } from "./AccountHold.vue?vue&type=template&id=c0bfcb42"
import script from "./AccountHold.vue?vue&type=script&lang=js"
export * from "./AccountHold.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__